import { useEffect } from "react";

import { Spinner } from "@/components/Spinner";
import useOrganisationOnboardingStatus from "@/hooks/organisations/useOrganisationOnboardingStatus";

export default function OnboardingStatusChecker({ onChange = () => {} }) {
  const { loading } = useOrganisationOnboardingStatus();

  useEffect(() => {
    onChange(loading);
  }, [loading, onChange]);

  if (loading) {
    return <Spinner />;
  }

  return null;
}
